import * as action_types from '../actions/action_types';

const initialState = {
  key: '',
  id: '',
  original: {},
};

export const AssetAppReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case action_types.SYNC_ASSET_HEALTH_MAP_WITH_TABLE:
      return {
        ...state,
        key: action.data.key,
        id: action.data.id,
        original: action.data.original,
      };
    default:
      return state;
  }
};
